import { getValidationResolver, useForm } from '@common-fe/common-fe';
import * as yup from 'yup';

import { VALIDATORS } from '@/common';
import { REQUIRED_TEXT, SSN_INVALID_TEXT } from '@/common/constants';
import regexp from '@/common/regexp';
import { IDependentInfoDtoRelationshipTypeEnum } from '@/dtos';
import { isDateInFuture } from '@/utils';

export enum AddFamilyMemberFormField {
  firstName = 'firstName',
  lastName = 'lastName',
  dateOfBirth = 'dateOfBirth',
  ssn = 'ssn',
  relationship = 'relationship',
}

export interface AddFamilyMemberForm {
  [AddFamilyMemberFormField.firstName]: string;
  [AddFamilyMemberFormField.lastName]: string;
  [AddFamilyMemberFormField.dateOfBirth]: string;
  [AddFamilyMemberFormField.ssn]: string;
  [AddFamilyMemberFormField.relationship]: IDependentInfoDtoRelationshipTypeEnum | undefined;
}

interface Props {
  defaultValues?: Partial<AddFamilyMemberForm>;
}

const useAddFamilyMemberForm = ({ defaultValues }: Props) => {
  const validationSchema = {
    [AddFamilyMemberFormField.firstName]: VALIDATORS.REQUIRED_STRING,
    [AddFamilyMemberFormField.lastName]: VALIDATORS.REQUIRED_STRING,
    [AddFamilyMemberFormField.dateOfBirth]: yup
      .string()
      .required(REQUIRED_TEXT)
      .test('date', 'Date cannot be in the future', (date) => !isDateInFuture(date)),
    [AddFamilyMemberFormField.ssn]: yup
      .string()
      .matches(regexp.SSN_WITH_DASHES, { message: SSN_INVALID_TEXT, excludeEmptyString: true }),
    [AddFamilyMemberFormField.relationship]: VALIDATORS.REQUIRED_STRING,
  };

  const methods = useForm<AddFamilyMemberForm>({
    defaultValues: {
      [AddFamilyMemberFormField.firstName]: defaultValues?.[AddFamilyMemberFormField.firstName] || '',
      [AddFamilyMemberFormField.lastName]:  defaultValues?.[AddFamilyMemberFormField.lastName] || '',
      [AddFamilyMemberFormField.dateOfBirth]: '',
      [AddFamilyMemberFormField.ssn]: '',
      [AddFamilyMemberFormField.relationship]: undefined,
    },
    resolver: getValidationResolver(validationSchema)
  });

  return { methods };
};

export default useAddFamilyMemberForm;
